// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

// import EditorController from "./editor_controller"
// application.register("editor", EditorController)

import MetadataController from "./metadata_controller"
application.register("metadata", MetadataController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

// import ToolbarController from "./toolbar_controller"
// application.register("toolbar", ToolbarController)

import VisualEditorController from "./visual_editor_controller"
application.register("visual-editor", VisualEditorController)
